import retailFullcont from './retail-fullcont.html'

const dialog = require('../../../../../components/dialog/dialog')
const dbRequest = require('../../../../../js-network/db-request')
const dtGenerator = require('../../../../../components/dt/dt-generator')
const fullcontEntity = require('../../../../../components/fullcont/fullcont-entity')
const fullcontForm = require('../../../../../components/fullcont/fullcont-form')
const fullcontFormHandler = require('../../../../../components/fullcont/fullcont-form-handler')
const fullcontHandler = require('../../../../../components/fullcont/fullcont-handler')
const autocompleteHandler = require('../../../../../components/textfield/autocomplete-handler')
const inf = require('../../../../../js-network/inf')
const snack = require('../../../../../components/snack/snack')
const timeDate = require('../../../../../js-handler/time-date')
const websocket = require('../../../../../js-network/web-socket')
const itemInventorySocket = require('../item/item-inventory-web-socket')
const retailDt = require('./retail-dt')
const handler = require('./retail-fullcont-handler')
const { form } = require('./retail-fullcont-form')
const { formCopy } = require('./retail-fullcont-form')
const { retailMT } = require('./retail-fullcont-multitable')

var htmlFc = {}
var HTMLwasSelected = false
const FULLCONT_OPEN_DELAY_MS = 350

function HTMLselect() {
      fullcontHandler.HTMLselect(
            'retail',
            'retail',
            'retail-fullcont',
            retailFullcont,
            form,
            formCopy,
            retailMT,
            editDialog,
            deleteDialog,
            dtCall,
            htmlFc,
      )

      htmlFc.addOne = 'server/php/sql/retailInsert.php'
      htmlFc.selectOne = 'server/php/sql/retailSelectOne.php'
      htmlFc.update = 'server/php/sql/retailUpdate.php'
      HTMLwasSelected = true
}

export function start(detail) {
      if (!HTMLwasSelected) { HTMLselect() }
      obj[detail.act].start(detail)
}

const obj = {
      addOne:             { start: (detail) => { fullcontEntity.addOne(detail, htmlFc, afterProcess) } },
      addOnePrint:        { start: (detail) => { fullcontEntity.addOne(detail, htmlFc, afterProcessAndPrint) } },
      calculate_values:   { start: (detail) => { handler.calculateValues(detail, htmlFc)             } },
      calculateGrandTotal:{ start: () => { setTimeout(() => handler.calculateGrandTotal(htmlFc), 0)  } },
      cancelEdit:         { start: (detail) => { fullcontEntity.cancelEdit(detail, htmlFc)            } },
      deleteEntity:       { start: (detail) => { fullcontEntity.deleteEntity(detail, htmlFc)          } },
      deleteFromDialog:   { start: (detail) => { deleteFromDialog(detail)                              } },
      discard:            { start: (detail) => { fullcontHandler.discard(detail, htmlFc)              } },
      hide:               { start: (detail) => { fullcontEntity.hide(detail, htmlFc)                  } },
      otherFieldItem:     { start: (detail) => { handler.otherFieldItem(detail, htmlFc)               } },
      prepareAdd:         { start: (detail) => { fullcontEntity.prepareAdd(detail, htmlFc, setDefaultValue) } },
      prepareEdit:        { start: (detail) => { fullcontHandler.prepareEdit(detail, htmlFc)          } },
      print:              { start: () => { printRetail()                                              } },
      saveFromDialog:     { start: (detail) => { saveFromDialog(detail)                                } },
      selectOne:          { start: (detail) => { fullcontEntity.selectOne(detail, htmlFc, afterSelect) } },
      selectOneNoCheck:   { start: (detail) => { fullcontEntity.selectOneNoCheck(detail, htmlFc, afterSelect) } },
      update:             { start: (detail) => { fullcontEntity.update(detail, htmlFc, afterUpdate)   } },
      updatePrint:        { start: (detail) => { fullcontEntity.update(detail, htmlFc, afterUpdateAndPrint) } },
}

function editDialog() {
      dialog.start({ act: 'show', id: 'saveChanges', entity: 'retail' })
}

function deleteDialog(detail) {
      dialog.start({ act: 'show', dest: 'retail', id: 'deleteElem', entity: 'retail', dbid: detail.dbid })
}

function dtCall(act, result) {
      retailDt.start({ act: act, row: result })
}

function deleteFromDialog(detail) {
      inf.toDelete(detail)

      dbRequest.start(detail, 'server/php/sql/retailDelete.php')
            .then((result) => {
                  if (result.status !== 'ok' || result.restriction?.val !== 'ok') { throw result }

                  dtGenerator.deleteRow(detail)
                  fullcontHandler.controlAfterDelete(detail)

                  const sendDetail = { to: 'allStaff', from: 'staffDesktop', id: '' }
                  websocket.entityUpdate('entityUpdate', 'deleteRow', detail, sendDetail)
            })
            .catch(() => {
                  snack.start({ act: 'show', id: 'updateError' })
            })
}

function setDefaultValue(htmlFc) {
      const saleDate = htmlFc.fullcontHTML.querySelector('#retail_form_sale_date input')
      const grandTotal = htmlFc.fullcontHTML.querySelector('#retail_form_grand_total input')
      const paymentMethod = htmlFc.form.find((element) => element.name === 'payment_method')
      const paymentMethodCopy = htmlFc.formCopy.find((element) => element.name === 'payment_method')
      const today = timeDate.convertDateToInput()

      handler.clearChanges(htmlFc)
      handler.setTaxPercentage(htmlFc, 0)
      saleDate.value = today
      grandTotal.value = '0.00'

      if (paymentMethod !== undefined) {
            paymentMethod.value = 'Cash'
            fullcontFormHandler.fill(paymentMethod)
      }

      if (paymentMethodCopy !== undefined) {
            paymentMethodCopy.value = 'Cash'
      }

      loadDefaultAccount(htmlFc)

      htmlFc.formCopy.forEach((element) => {
            if (element.name === 'sale_date') { element.value = today }
            if (element.name === 'grand_total') { element.value = '0.00' }
      })

      setTimeout(() => {
            const retailIsOpen = htmlFc.fullcontHTML.classList.contains('fullcont-show')
            const retailIsAdding = htmlFc.fullcontHTML.classList.contains('mode-add')

            if (retailIsOpen && retailIsAdding) {
                  retailMT[0].add()
                  setInitialMultitableState()
            }
      }, FULLCONT_OPEN_DELAY_MS)
}

// Selecciona la cuenta configurada en Company solo al crear un Retail nuevo.
// Si no existe una configuracion valida, el campo queda vacio para seleccionarlo.
function loadDefaultAccount(htmlFc) {
      const detail = { inf: { entity: 'retail' } }

      dbRequest.start(detail, 'server/php/sql/retailDefaultAccount.php')
            .then((result) => {
                  const retailIsOpen = htmlFc.fullcontHTML.classList.contains('fullcont-show')
                  const retailIsAdding = htmlFc.fullcontHTML.classList.contains('mode-add')
                  const defaults = result?.data?.[0]
                  const accountField = htmlFc.form.find((element) => element.name === 'accounts_id')
                  const accountFieldCopy = htmlFc.formCopy.find((element) => element.name === 'accounts_id')

                  if (
                        result?.status !== 'ok'
                        || !retailIsOpen
                        || !retailIsAdding
                        || !defaults
                  ) {
                        return
                  }

                  handler.applyTaxPercentageToItems(htmlFc, defaults.tax_percentage)

                  if (
                        !defaults.id
                        || !accountField
                        || !accountFieldCopy
                        || accountField.html.getAttribute('selected') !== '[]'
                  ) { return }

                  const selectedId = String(defaults.id)
                  const valueFull = [{
                        id: selectedId,
                        displayText: String(defaults.displayText),
                  }]

                  accountField.value = [selectedId]
                  accountField.valueFull = valueFull
                  accountFieldCopy.value = [selectedId]
                  accountFieldCopy.valueFull = JSON.parse(JSON.stringify(valueFull))
                  autocompleteHandler.fill(accountField)
            })
}

// La primera linea vacia es parte del estado inicial de una factura nueva.
// Asi, wasEdited solo detecta datos ingresados por el usuario.
function setInitialMultitableState() {
      fullcontForm.getValues(htmlFc)

      retailMT.forEach((multitable) => {
            multitable.dataCopy = JSON.parse(JSON.stringify(multitable.data))
      })
}

function afterProcess(data, result) {
      if (processInventoryValidation(result)) { return false }
      if (result?.restriction?.val && result.restriction.val !== 'ok') { return false }

      setTaxPercentageFromResult(result)
      handler.calculateGrandTotal(htmlFc)
      handler.renderChanges(result, htmlFc)

      if (data) {
            itemInventorySocket.notifySavedInventory('sale', data, result)
      }

      return true
}

function afterProcessAndPrint(data, result) {
      if (!afterProcess(data, result) || !data?.id) { return }

      handler.pdfMenudt({ dbid: data.id })
}

function afterUpdate(data, result) {
      return afterProcess(data, result)
}

function afterUpdateAndPrint(data, result) {
      if (!afterUpdate(data, result) || !data?.id) { return }

      handler.pdfMenudt({ dbid: data.id })
}

function printRetail() {
      const retailId = htmlFc.fullcontHTML.getAttribute('data-dbid')

      handler.pdfMenudt({ dbid: retailId })
}

function saveFromDialog(detail) {
      const isUpdate = !htmlFc.fullcontHTML.classList.contains('mode-add')
      const callback = isUpdate ? afterUpdate : afterProcess

      fullcontEntity.saveFromDialog(detail, htmlFc, callback)
}

function processInventoryValidation(result) {
      if (result?.restriction?.val !== 'validationFailed') { return false }

      handler.updateInventoryAvailability(result, htmlFc)
      return true
}

function afterSelect(data, result) {
      setTaxPercentageFromResult(result)
      handler.calculateGrandTotal(htmlFc)
      handler.renderChanges(result, htmlFc)
}

function setTaxPercentageFromResult(result) {
      const percentage = result?.data?.[0]?.tax_percentage
      if (percentage === undefined) { return }

      handler.setTaxPercentage(htmlFc, percentage)
}
